<div class="panel panel-flat">
  <div class="content-group">
    <div class="page-header page-header-default">
      <div class="page-header-content">
        <div class="page-title">
          <h5>
            <i class="icon-stack position-left"></i>
            <span class="text-semibold">Branches</span>
          </h5>
        </div>

        <div class="heading-elements">
          <div class="btn-group pull-right">
            <a [routerLink]="['/branchadd']" type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-add position-left"></i> Add Branch</a>
            <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-printer position-left"></i>Print</a>
            <a type="button" (click)="unlockView()" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-unlocked position-left"></i>Unlock</a>
          </div>
        </div>
      </div>
    </div>

    <!--     <div class="row" style="padding-left:30px;">
      <div class="col-md-2 form-group required">
        <span style="float:left" class="control-label">Filter by: Status</span>
        <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getBranchFilter()"
          class="form-control">
          <option value="" selected>All</option>
          <option value="&status=pending">Pending</option>
          <option value="&status=confirmed">Confirmed</option>
          <option value="&status=declined">Declined</option>
        </select>
      </div>

      <div class="col-md-2 form-group required">
        <span style="float:left" class="control-label">Filter by: Type</span>
        <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getBranchFilter()"
          class="form-control">
          <option value="&status=" selected>All</option>
          <option value="&type=deposit">Deposit</option>
          <option value="&type=fine">Fine</option>
          <option value="&type=award">Award</option>
        </select>
      </div>

      <div class="col-md-3 form-group required">
        <span class="control-label">&nbsp; </span>
      </div>
    </div> -->

    <div class="panel-body">
      <table class="table datatable-column-search-inputs">
        <thead>
          <tr>
            <th>Name</th>
            <th>Address</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Contact Person</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let branch of branches | paginate: { id: 'branches',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
            <td>
              <div class="media">
                <div class="media-left">{{branch.name}}
                  <div class="text-muted text-size-small">
                    {{branch.region}} - {{branch.city}}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="media">
                <div class="media-left">{{branch.sub_city}}
                  <div class="text-muted text-size-small">
                    {{branch.woreda_kebele}} - {{branch.house_no}}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="media">
                <div class="media-left">{{branch.phone_number_1}}
                  <div class="text-muted text-size-small">
                    {{branch.phone_number_2}}
                  </div>
                </div>
              </div>
            </td>
            <td>{{branch.email}}</td>
            <td>{{branch.contact_person}}</td>
            <td>
              <span class="label label-block label-default"
                *ngIf="branch.status === 'Pending' || branch.status === 'pending'">{{branch.status}}</span>
              <span class="label label-block label-primary"
                *ngIf="branch.status === 'Active' || branch.status === 'active'">{{branch.status}}</span>
              <span class="label label-block label-danger"
                *ngIf="branch.status === 'Closed' || branch.status === 'closed'">{{branch.status}}</span>
            </td>
            <td class="text-center">
              <ul class="icons-list">
                <li class="dropdown">
                  <a href="" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="icon-menu9"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a href="" [routerLink]="['/branchadd']" [queryParams]="{'id':branch.id}">
                        <i class="icon-file-pdf"></i>Update</a>
                    </li>
                    <li>
                      <a href="">
                        <i class="icon-file-excel"></i>Delete</a>
                    </li>
                    <li class="dropdown-submenu dropdown-submenu-left">
                      <a href="javascript:void(0);">Change Status</a>
                      <ul class="dropdown-menu">
                        <li>
                          <a (click)="changeStatus(branch.id,'pending')">
                            <i class="icon-shuffle"></i> Pending</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(branch.id,'active')">
                            <i class="icon-shuffle"></i> Active</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(branch.id,'closed')">
                            <i class="icon-shuffle"></i> Closed</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr *ngIf="branches.length <=0">
            <td colspan="11" class="text-center"> <i class="icon-info22">&nbsp;</i>No Branches yet!</td>
          </tr>
        </tbody>
      </table>

      <br>

      <div class="row">
        <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
        <div class="text-center">

          <pagination-controls id="branches" (pageChange)="pageChanged(currentPage = $event)">
          </pagination-controls>

          <br>
        </div>

      </div>


    </div>
  </div>
</div>